import { useTranslation } from "@/i18n";

import XBall from "./XBall";
/**
 * BallLoader - the app's universal loading indicator: the bouncing 🏀 with
 * squash-on-impact (same animation as the Nutri-Check lookup). Use it for any
 * section/screen "loading…" state so the whole app feels consistent.
 *
 * The caption is ALWAYS shown by default (v15.07). It used to default to null,
 * so most screens showed a bare bouncing ball with no words while others said
 * "Loading" - the same wait looked like two different things depending on where
 * you were. Now every ball says it, translated, unless a caller deliberately
 * passes `label={null}`.
 *
 * Not intended for tiny in-button spinners - a bouncing ball needs vertical
 * room and would clip inside a 40px button.
 */
export default function BallLoader({ size = 40, label, className = "" }) {
  const { t } = useTranslation();
  // `undefined` (prop omitted) -> the default caption.
  // `null` (explicitly passed) -> no caption, for the rare cramped spot.
  const text = label === undefined ? (t("common.loading") || "Loading…") : label;
  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <XBall size={size} className="nutri-ball" />
      {text ? <p className="text-sm text-gray-500 dark:text-gray-400 font-medium">{text}</p> : null}
    </div>
  );
}
